import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { postApi } from '../service/service';
import { API_URL, DOMAIN } from '../config';
import CircularLoader from '../components/common/loader/loader';
import MetaDecorator from '../components/common/loader/metaDecorator';
import { getToken, isAuthenticated } from '../utils/auth';
import imgUrl from '../images/badela-satsang.jpeg';
// import FacebookVideo from '../components/FacebookVideo/FacebookVideo';

import './Home.css';

const Home = ({ match, history }) => {
  const [isLogin, setLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [satsangList, setSatsangList] = useState([]);
  const [latestVideo, setLatestVideo] = useState(null);
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    setLogin(isAuthenticated());
  }, []);

  useEffect(() => {
    getSatsangList(`${API_URL}/satsang/list`);
  }, []);

  useEffect(() => {
    setInterval(() => {
      fetch(`${API_URL}/health`).then((res) => {
        console.log(res);
      });
    }, 13*60*1000);
  }, []); 

  const getSatsangList = (apiUrl) => {
    const token = getToken();
    let header = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
      body = {};
    postApi(apiUrl, header, body).then((data) => {
      setIsLoading(false);
      // Check if data is from cache (offline)
      if (data.offline || data.cached) {
        setIsOffline(true);
      } else {
        setIsOffline(false);
      }
      if (data.status && data.data) {
        // Filter out deleted items (isDeleted !== true)
        const filteredData = data.data.filter((item) => !item.isDeleted);
        setSatsangList(filteredData);
        
        // Find latest video (post with iframe - YouTube or Facebook)
        const videosWithIframes = filteredData.filter((item) => {
          if (!item.description) return false;
          // Check if description contains iframe tag
          const hasIframe = /<iframe[^>]+>/i.test(item.description);
          if (!hasIframe) return false;
          
          // Extract iframe src to check if it's YouTube or Facebook
          const iframeMatch = item.description.match(/<iframe[^>]+src=["']([^"']+)["'][^>]*>/i);
          if (!iframeMatch || !iframeMatch[1]) return false;
          
          const src = iframeMatch[1].toLowerCase();
          // Check if it's YouTube or Facebook video
          return src.includes('youtube.com') || 
                 src.includes('youtu.be') || 
                 src.includes('facebook.com') || 
                 src.includes('fb.com') ||
                 src.includes('vimeo.com');
        });
        
        if (videosWithIframes.length > 0) {
          // Sort by createdAt to get the latest
          const sortedVideos = videosWithIframes.sort((a, b) => {
            const dateA = a.createdAt ? new Date(a.createdAt) : new Date(0);
            const dateB = b.createdAt ? new Date(b.createdAt) : new Date(0);
            return dateB - dateA; // Latest first
          });
          
          const latest = sortedVideos[0];
          // Extract iframe from description
          const iframeMatch = latest.description.match(/<iframe[^>]+>.*?<\/iframe>/i);
          if (iframeMatch) {
            setLatestVideo({
              id: latest._id,
              name: latest.name,
              iframeHtml: iframeMatch[0],
              category: latest.category
            });
          }
        }
      } else {
        // If no data or error, set empty list
        setSatsangList([]);
        setLatestVideo(null);
      }
    }).catch((error) => {
      setIsLoading(false);
      // Check if error response contains cached data
      if (error.offline || error.statusCode === 503) {
        setIsOffline(true);
        // Try to use any partial data if available
        if (error.data && Array.isArray(error.data)) {
          setSatsangList(error.data.filter((item) => !item.isDeleted));
        } else {
          setSatsangList([]);
        }
      } else {
        setIsOffline(false);
        setSatsangList([]);
      }
      console.error('Error loading satsang list:', error.message || error.msg);
    });
  };

  return (
    <div>
      <MetaDecorator 
        title='बड़ेला धाम भारतवर्ष' 
        description='बड़ेला धाम भारतवर्ष - सतगुरु जयगुरूदेव जी महाराज के संदेश और सत्संग'
        imgSrc={`${DOMAIN}/fb-meta-home.jpg`}  
      />
      <script
        data-ad-client="ca-pub-3514662431507118"
        async
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"
      ></script>
      <div style={{ minHeight: '700px' }}>
        <div class="jumbotron"></div>
        {isLoading ? <div className='loader-container'><CircularLoader /></div> : <div
          className="main-page-container"
          style={{ position: 'static', width: 'auto' }}
        >
          {isLogin && (
            <Button style={{ position: 'relative', left: '60%' }} variant="">
              <Link className="" to="/satsang/add">
                Add Satsang
              </Link>
            </Button>
          )}
          
          {/* Offline Indicator */}
          {isOffline && (
            <div style={{
              padding: '10px',
              marginBottom: '15px',
              backgroundColor: '#fff3cd',
              border: '1px solid #ffc107',
              borderRadius: '4px',
              textAlign: 'center',
              color: '#856404',
              fontSize: '14px'
            }}>
              📴 You are offline. Showing cached data.
            </div>
          )}
          {/* Facebook Latest Video Section - Top of Page */}
          {/* <FacebookVideo 
            pageId={process.env.REACT_APP_FACEBOOK_PAGE_ID}
            pageName={process.env.REACT_APP_FACEBOOK_PAGE_NAME}
            profileId={process.env.REACT_APP_FACEBOOK_PROFILE_ID}
            profileName={process.env.REACT_APP_FACEBOOK_PROFILE_NAME}
            videoUrl={process.env.REACT_APP_FACEBOOK_LATEST_VIDEO_URL}
            accessToken={process.env.REACT_APP_FACEBOOK_ACCESS_TOKEN}
          /> */}
          
          {/* Latest Video Section */}
          {latestVideo && (
            <div style={{ 
              marginBottom: '30px', 
              padding: '20px', 
              backgroundColor: '#f9f9f9', 
              borderRadius: '8px',
              border: '1px solid #ddd',
              position: 'relative'
            }}>
              <style>{`
                @media (min-width: 768px) {
                  .latest-video-new-label {
                    left: 31% !important;
                  }
                }
                @media (max-width: 767px) {
                  .latest-video-new-label {
                    left: -1% !important;
                  }
                }
              `}</style>
              <h4 style={{ marginBottom: '15px', textAlign: 'center', color: '#1717e6', position: 'relative' }}>
                <span className="latest-video-new-label" style={{
                  position: 'absolute',
                  top: '-4%',
                  left: '-1%',
                  fontSize: '12px',
                  color: 'red',
                  fontWeight: 'normal',
                  marginRight: '8px',
                  whiteSpace: 'nowrap'
                }}>New</span>
                {latestVideo.name}
              </h4>
              <div 
                className="sub-content" 
                style={{ 
                  display: 'flex', 
                  justifyContent: 'center',
                  width: '100%',
                  maxWidth: '100%'
                }}
                dangerouslySetInnerHTML={{ __html: latestVideo.iframeHtml }}
              ></div>
            </div>
          )}
          
          <div style={{ position: 'static', marginBottom: '10px' }}>
            <Link className="" to="/world-message" style={{ color: '#1717e6' }}>
              स्वामी जी महाराज का संदेश-विश्व के समस्त प्रेमियो के लिए Swami Ji Maharaj’s message for all the devotees of the world.
            </Link>
          </div>
          <h4>बड़ेला-धाम नवीन सुचनायें एवं सेवा कार्य</h4>
          <div className="home-list-container">
            <ul className="navbar-nav ml-auto">
              {!isLoading &&
                satsangList
                  .filter((row) => row.category === 8)
                  .map((row, i) => {
                    if (i < 5) {
                      const route = `/navin-suchnaye/${row._id}`;
                      return (
                        <Link className="" to={route} style={{ color: '#1717e6', fontSize: '1.35em' }}>
                          {row.name}
                        </Link>
                      );
                    }
                  })}
            </ul>
            {!isLoading && satsangList.filter((row) => row.category === 8).length > 5 && (
              <div style={{ position: 'static' }}>
                <Link className="" to="/navin-suchnaye" style={{ color: '#1717e6' }}>
                  see more list...
                </Link>
              </div>
            )}
          </div>
          <h4></h4>
          <h4>कुंभ-माघ मेले में शाकाहार प्रचार-प्रसार</h4>
          <div className="home-list-container">
            <ul className="navbar-nav ml-auto">
              {!isLoading &&
                satsangList
                  .filter((row) => row.category === 15)
                  .map((row, i) => {
                    if (i < 5) {
                      const route = `/kumbh-magh-shakahar/${row._id}`;
                      return (
                        <Link key={row._id} className="" to={route} style={{ color: '#1717e6', fontSize: '1.35em' }}>
                          {row.name}
                        </Link>
                      );
                    }
                    return null;
                  })}
            </ul>
            {!isLoading && satsangList.filter((row) => row.category === 15).length > 5 && (
              <div style={{ position: 'static' }}>
                <Link className="" to="/kumbh-magh-shakahar" style={{ color: '#1717e6' }}>
                  see more list...
                </Link>
              </div>
            )}
          </div>
          <h4></h4>
          <h4>प्रमुख अन्तर्घट संदेश</h4>
          <div className="home-list-container">
            <ul className="navbar-nav ml-auto">
              {!isLoading &&
                satsangList
                  .filter((row) => row.category === 13)
                  .map((row, i) => {
                    if (i < 5) {
                      const route = `/pramukh-antargat-sandesh/${row._id}`;
                      return (
                        <Link className="" to={route} style={{ color: '#1717e6', fontSize: '1.35em' }}>
                          {row.name}
                        </Link>
                      );
                    }
                  })}
            </ul>
            {!isLoading && satsangList.filter((row) => row.category === 13).length > 5 && (
              <div style={{ position: 'static' }}>
                <Link className="" to="/pramukh-antargat-sandesh" style={{ color: '#1717e6' }}>
                  see more list...
                </Link>
              </div>
            )}
          </div>
          <h4></h4>
          <h4>बड़ेला-धाम सत्संग</h4>
          <div className="home-list-container">
            <ul className="navbar-nav ml-auto">
              {!isLoading &&
                satsangList
                  .filter((row) => row.category === 2)
                  .map((row, i) => {
                    if (i < 5) {
                      const route = `/badela-satsang/${row._id}`;
                      return (
                        <Link className="" to={route} style={{ color: '#1717e6', fontSize: '1.35em' }}>
                          {row.name}
                        </Link>
                      );
                    }
                  })}
            </ul>
            {!isLoading && satsangList.filter((row) => row.category === 2).length > 5 && (
              <div style={{ position: 'static' }}>
                <Link
                  className=""
                  to="/badela-satsang"
                  style={{ color: '#1717e6' }}
                >
                  see more list..
                </Link>
              </div>
            )}
          </div>
          <h4></h4>
          <h4>स्वामी जी महाराज सत्संग वचन</h4>
          <div className="home-list-container">
            <ul className="navbar-nav ml-auto">
              {!isLoading &&
                satsangList
                  .filter((row) => row.category === 1)
                  .map((row, i) => {
                    if (i < 5) {
                      const route = `/jgd-satsang/${row._id}`;
                      return (
                        <Link className="" to={route} style={{ color: '#1717e6', fontSize: '1.35em' }}>
                          {row.name}
                        </Link>
                      );
                    }
                  })}
            </ul>
            {!isLoading && satsangList.filter((row) => row.category === 1).length > 5 && (
              <div style={{ position: 'static' }}>
                <Link className="" to="/jgd-satsang" style={{ color: '#1717e6' }}>
                  see more list..
                </Link>
              </div>
            )}
          </div>
          <h4></h4>
          <h4>प्रेमीयो के निज अंतर-अनुभव</h4>
          <div className="home-list-container">
            <ul className="navbar-nav ml-auto">
              {!isLoading &&
                satsangList
                  .filter((row) => row.category === 7)
                  .map((row, i) => {
                    if (i < 5) {
                      const route = `/nij-anubhav/${row._id}`;
                      return (
                        <Link className="" to={route} style={{ color: '#1717e6', fontSize: '1.35em' }}>
                          {row.name}
                        </Link>
                      );
                    }
                  })}
            </ul>
            {!isLoading && satsangList.filter((row) => row.category === 7).length > 5 && (
              <div style={{ position: 'static' }}>
                <Link className="" to="/nij-anubhav" style={{ color: '#1717e6' }}>
                  see more list..
                </Link>
              </div>
            )}
          </div>
          <h4></h4>
          <h4>बड़ेला-धाम:- आंतरिक प्रार्थना</h4>
          <div className="home-list-container">
            <ul className="navbar-nav ml-auto">
              {!isLoading &&
                satsangList
                  .filter((row) => row.category === 12)
                  .map((row, i) => {
                    if (i < 5) {
                      const route = `/aantarik-prarthna/${row._id}`;
                      return (
                        <Link className="" to={route} style={{ color: '#1717e6', fontSize: '1.35em' }}>
                          {row.name}
                        </Link>
                      );
                    }
                  })}
            </ul>
            {!isLoading && satsangList.filter((row) => row.category === 12).length > 5 && (
              <div style={{ position: 'static' }}>
                <Link className="" to="/aantarik-prarthna" style={{ color: '#1717e6' }}>
                  see more list..
                </Link>
              </div>
            )}
          </div>
          <h4></h4>
          <h4>संगत की प्रचलित-प्रार्थनायें</h4>
          <div className="home-list-container">
            <ul className="navbar-nav ml-auto">
              {!isLoading &&
                satsangList
                  .filter((row) => row.category === 3)
                  .map((row, i) => {
                    if (i < 5) {
                      const route = `/prarthna/${row._id}`;
                      return (
                        <Link className="" to={route} style={{ color: '#1717e6', fontSize: '1.35em' }}>
                          {row.name}
                        </Link>
                      );
                    }
                  })}
            </ul>
            {!isLoading && satsangList.filter((row) => row.category === 3).length > 5 && (
              <div style={{ position: 'static' }}>
                <Link className="" to="/prarthna" style={{ color: '#1717e6' }}>
                  see more list..
                </Link>
              </div>
            )}
          </div>
          <h4></h4>
          <h4>साधकों की कलम से</h4>
          <div className="home-list-container">
            <ul className="navbar-nav ml-auto">
              {!isLoading &&
                satsangList
                  .filter((row) => row.category === 14)
                  .map((row, i) => {
                    if (i < 5) {
                      const route = `/sadhakon-ki-kalam-se/${row._id}`;
                      return (
                        <Link className="" to={route} style={{ color: '#1717e6', fontSize: '1.35em' }}>
                          {row.name}
                        </Link>
                      );
                    }
                  })}
            </ul>
            {!isLoading && satsangList.filter((row) => row.category === 14).length > 5 && (
              <div style={{ position: 'static' }}>
                <Link className="" to="/sadhakon-ki-kalam-se" style={{ color: '#1717e6' }}>
                  see more list..
                </Link>
              </div>
            )}
          </div>
          <h4></h4>
          <h4>बड़ेला-धाम परिचय</h4>
          <div className="home-list-container">
            <ul className="navbar-nav ml-auto">
              {!isLoading &&
                satsangList
                  .filter((row) => row.category === 6)
                  .sort((a, b) => {
                    // Sort by createdAt if available, otherwise by _id (which contains timestamp)
                    let dateA, dateB;
                    if (a.createdAt) {
                      dateA = new Date(a.createdAt);
                    } else {
                      // Extract timestamp from MongoDB ObjectId (first 4 bytes = 8 hex chars)
                      const timestampA = parseInt(a._id.toString().substring(0, 8), 16);
                      dateA = new Date(timestampA * 1000);
                    }
                    if (b.createdAt) {
                      dateB = new Date(b.createdAt);
                    } else {
                      // Extract timestamp from MongoDB ObjectId (first 4 bytes = 8 hex chars)
                      const timestampB = parseInt(b._id.toString().substring(0, 8), 16);
                      dateB = new Date(timestampB * 1000);
                    }
                    return dateA - dateB; // Ascending order (oldest first, newest last)
                  })
                  .map((row, i) => {
                    if (i < 5) {
                      const route = `/badela-dham/${row._id}`;
                      return (
                        <Link className="" to={route} style={{ color: '#1717e6', fontSize: '1.35em' }}>
                          {row.name}
                        </Link>
                      );
                    }
                  })}
            </ul>
            {!isLoading && satsangList.filter((row) => row.category === 6).length > 5 && (
              <div style={{ position: 'static' }}>
                <Link
                  className=""
                  to="/badela-dham"
                  style={{ color: '#1717e6' }}
                >
                  see more list..
                </Link>
              </div>
            )}
          </div>
          <h4></h4>
          <h4>स्वामी जी फोटो-गैलरी</h4>
          <div className="home-list-container">
            <ul className="navbar-nav ml-auto">
              {!isLoading &&
                satsangList
                  .filter((row) => row.category === 9)
                  .map((row, i) => {
                    if (i < 5) {
                      const route = `/jgd-pic/${row._id}`;
                      return (
                        <Link className="" to={route} style={{ color: '#1717e6', fontSize: '1.35em' }}>
                          {row.name}
                        </Link>
                      );
                    }
                  })}
            </ul>
            {!isLoading && satsangList.filter((row) => row.category === 9).length > 5 && (
              <div style={{ position: 'static' }}>
                <Link className="" to="/jgd-pic" style={{ color: '#1717e6' }}>
                  see more list...
                </Link>
              </div>
            )}
          </div>
          <h4></h4>
          <h4>बड़ेला-धाम फोटो-गैलरी</h4>
          <div className="home-list-container">
            <ul className="navbar-nav ml-auto">
              {!isLoading &&
                satsangList
                  .filter((row) => row.category === 10)
                  .map((row, i) => {
                    if (i < 5) {
                      const route = `/badela-pic/${row._id}`;
                      return (
                        <Link className="" to={route} style={{ color: '#1717e6', fontSize: '1.35em' }}>
                          {row.name}
                        </Link>
                      );
                    }
                  })}
            </ul>
            {!isLoading && satsangList.filter((row) => row.category === 10).length > 5 && (
              <div style={{ position: 'static' }}>
                <Link className="" to="/badela-pic" style={{ color: '#1717e6' }}>
                  see more list...
                </Link>
              </div>
            )}
          </div>
          <h4></h4>
          <h4>जीवन-परिचय</h4>
          <div className="home-list-container">
            <ul className="navbar-nav ml-auto">
              {!isLoading &&
                satsangList
                  .filter((row) => row.category === 5)
                  .map((row, i) => {
                    if (i < 5) {
                      const route = `/jivani/${row._id}`;
                      return (
                        <Link className="" to={route} style={{ color: '#1717e6', fontSize: '1.35em' }}>
                          {row.name}
                        </Link>
                      );
                    }
                  })}
            </ul>
            {!isLoading && satsangList.filter((row) => row.category === 5).length > 5 && (
              <div style={{ position: 'static' }}>
                <Link className="" to="/jivani" style={{ color: '#1717e6' }}>
                  see more list..
                </Link>
              </div>
            )}
          </div>
          <h4></h4>
          <h4>स्वामीजी महाराज द्वारा सुनायी गयी कहानियाँ</h4>
          <div className="home-list-container">
            <ul className="navbar-nav ml-auto">
              {!isLoading &&
                satsangList
                  .filter((row) => row.category === 4)
                  .map((row, i) => {
                    if (i < 5) {
                      const route = `/jgd-story/${row._id}`;
                      return (
                        <Link className="" to={route} style={{ color: '#1717e6', fontSize: '1.35em' }}>
                          {row.name}
                        </Link>
                      );
                    }
                  })}
            </ul>
            {!isLoading && satsangList.filter((row) => row.category === 4).length > 5 && (
              <div style={{ position: 'static' }}>
                <Link className="" to="/jgd-story" style={{ color: '#1717e6' }}>
                  see more list..
                </Link>
              </div>
            )}
          </div>
          <h4></h4>
        </div>}
      </div>
    </div>
  );
};

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.jsx